import React from 'react';
import { Route, Routes, useNavigate, useResolvedPath } from 'react-router-dom';
import { IAppointment } from '../../API/GoMoto';
import { useFullReset, useKioskState } from '../../context/Kiosk/kiosk';
import { LoadAppointment } from '../Utility/LoadAppointment';
import { PathName, PickUpQRCodeRoutePaths } from '../../helpers/Routes';
import { AppointmentDispatchTypes, useAppointmentDispatch, useAppointmentStateUnsafe } from '../../context/Appointment/appointment';
import { PickupQRCode } from './PickupQRCode';
import { LoadingRoute } from '../../controls/Route/LoadingRoute';

/**
 * Component for displaying pickup QR codes for non-365 kiosks
 */
export const PickupQRCodeIndex: React.FC = React.memo(() => {
    const { pathname: basePath } = useResolvedPath('.');
    const appointmentDispatch = useAppointmentDispatch();
    const appointment = useAppointmentStateUnsafe();
    const { dealer: { key: dealerKey } } = useKioskState();
    const navigate = useNavigate();
    const reset = useFullReset(true, false);

    return (
        <Routes>
            <Route
                path={PathName(PickUpQRCodeRoutePaths.Appointment, ':apptKey', '*')}
                element={
                    <LoadAppointment
                        onLoaded={(appointment: IAppointment) => {
                            if (!appointment || appointment.status === 'completed' || appointment.keyStatus !== 'slot_assigned' || appointment.paymentStatus === 'not paid') {
                                reset();
                            }
                            else {
                                appointmentDispatch({ type: AppointmentDispatchTypes.Update,
                                    payload: appointment });

                                navigate(PathName(basePath, PickUpQRCodeRoutePaths.QRCode), { replace: true });
                            }
                        }}
                    />
                }
            />
            <Route
                path={PathName(PickUpQRCodeRoutePaths.QRCode, '*')}
                element={
                    <LoadingRoute loaded={!!appointment && appointment.dealerKey === dealerKey}>
                        <PickupQRCode />
                    </LoadingRoute>
                }
            />
        </Routes>
    );
});
